import { Component, OnInit } from '@angular/core';
import { ILoadingCellRenderer, ILoadingCellRendererParams } from '@ag-grid-community/core';

@Component({
  selector: 'app-advanced-table-custom-loading',
  templateUrl: './advanced-table-custom-loading.component.html',
  styleUrls: ['./advanced-table-custom-loading.component.css']
})
export class AdvancedTableCustomLoadingComponent implements ILoadingCellRenderer {

  params: any;
  refresh: any;

  constructor() { }

  agInit(params): void {
    console.log(params);
    this.params = params;
  }

}
